import React, { useCallback, useEffect, useState } from "react";
import "./style.scss";
import MDBox from "components/MDBox";
import DesignForm from "./form";
import Paper from "@mui/material/Paper";
import { PhoneSize } from "types/enum/Common";
import { Business } from "types/Dashboard";
import { Avatar } from "@mui/material";
import MDButton from "components/MDButton";

type Props = {
  isEdit: boolean;
  campaign: Business;
  setFieldValue: (field: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any, Element>) => void;
  onClick: () => void;
};

const BusinessDesign: React.FC<Props> = (props) => {
  const { campaign, handleChange, handleBlur, setFieldValue, isEdit, onClick } =
    props;
  const [phoneStyle, setPhoneStyle] = useState({
    phoneWrapper: {
      backgroundColor: campaign.background_color
    },
    stampWrapper: {
      backgroundColor: campaign.stamp_color || "#000"
    }
  });
  useEffect(() => {
    setPhoneStyle({
      phoneWrapper: {
        backgroundColor: isEdit ? `${campaign.background_color}` : `red`
      },
      stampWrapper: {
        backgroundColor: campaign.stamp_color
          ? `${campaign.stamp_color}`
          : `#000000`
      }
    });
  }, [campaign.background_color, campaign.stamp_color, isEdit]);

  const autoSetFontColor = useCallback(() => {
    if (campaign.background_color) {
      setPhoneStyle((prev) => ({
        ...prev,
        phoneWrapper: {
          backgroundColor: `${campaign.background_color}`
        },
        stampWrapper: {
          backgroundColor: `${campaign.stamp_color}`
        }
      }));
    }
  }, [campaign.background_color, campaign.stamp_color]);

  useEffect(() => {
    autoSetFontColor();
  }, [autoSetFontColor]);

  return (
    <Paper sx={{ padding: 2, paddingBottom: 8 }}>
      <MDBox sx={{ width: "100%", display: "flex", marginBottom: 2 }}>
        <MDBox width={"30%"}>
          <DesignForm
            values={campaign}
            setFieldValue={setFieldValue}
            handleBlur={handleBlur}
            handleChange={handleChange}
          />
        </MDBox>
        <MDBox width={"35%"}>
          <MDBox className="phone-emulator">
            <MDBox
              className={`phone ${PhoneSize.IPHONE_10}`}
              style={phoneStyle.phoneWrapper}
            >
              <MDBox display={"flex"} justifyContent={"center"} mb={5}>
                <Avatar
                  sx={{
                    marginTop: 5,
                    width: 120,
                    height: 120,
                    border: `1px solid #f0f2f5`
                  }}
                  src={campaign.cafe_logo}
                />
              </MDBox>
              <MDBox
                className="phone-banner"
                style={{
                  ...phoneStyle.phoneWrapper
                }}
              >
                <div className="phone-data">
                  <MDBox className="title">
                    <p className="title-name">{campaign.name}</p>
                    <p className="title-area">({campaign.areas})</p>
                    <p className="title-desc">{campaign.description}</p>
                    <p className="title-name">{campaign.reward_name}</p>
                  </MDBox>

                  <MDBox padding={2} display="flex">
                    <MDBox
                      className="stamp"
                      style={{
                        ...phoneStyle.stampWrapper
                      }}
                    />
                    <MDBox
                      className="stamp"
                      style={{
                        ...phoneStyle.stampWrapper
                      }}
                    />
                  </MDBox>
                </div>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
        <MDBox width={"35%"}>
          <MDBox className="phone-emulator">
            <MDBox
              className={`phone ${PhoneSize.IPHONE_10}`}
              style={phoneStyle.phoneWrapper}
            >
              <MDBox
                className="phone-banner"
                style={{
                  ...phoneStyle.phoneWrapper
                }}
              >
                <div className="phone-data">
                  <MDBox className="title" mt={10}>
                    <p className="title-label">{"You have collected:"}</p>
                    <p className="title-name">xxx stamps</p>
                  </MDBox>
                  <MDBox display={"flex"} justifyContent={"center"} mb={5}>
                    <Avatar
                      sx={{
                        marginTop: 1,
                        width: 120,
                        height: 120,
                        border: `1px solid #f0f2f5`,
                        marginBottom: `2px !important;`
                      }}
                      src={campaign.cafe_logo}
                    />
                  </MDBox>
                  <MDBox className="title" mb={1}>
                    <p className="title-desc">{campaign.name}</p>
                  </MDBox>
                  <MDBox className="title" mb={1}>
                    <p className="title-details">Areas:{campaign.areas}</p>
                    <p className="title-details">
                      Location: {campaign.address}
                    </p>
                    <p className="title-details">
                      Opening Hours:{campaign.opening_hours}
                    </p>
                  </MDBox>
                  <MDBox className="title" mb={1}>
                    <p className="tile-reward">Rewards</p>
                    <p className="title-details">
                      {campaign.reward_condition &&
                        campaign.reward_condition
                          .split("\n")
                          .map((line, index) => (
                            <span key={index}>
                              {line}
                              <br />
                            </span>
                          ))}
                    </p>
                  </MDBox>
                </div>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>

      <MDButton
        variant="gradient"
        color="primary"
        onClick={onClick}
        mt={2}
        sx={{
          float: "right",
          width: 200,
          padding: 2
        }}
      >
        Update Details
      </MDButton>
    </Paper>
  );
};
export default BusinessDesign;
